/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetVisitRegistrationCalendarSlotDto
 */
export interface GetVisitRegistrationCalendarSlotDto {
    /**
     * 
     * @type {string}
     * @memberof GetVisitRegistrationCalendarSlotDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetVisitRegistrationCalendarSlotDto
     */
    firstname?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVisitRegistrationCalendarSlotDto
     */
    surname?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVisitRegistrationCalendarSlotDto
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVisitRegistrationCalendarSlotDto
     */
    mail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVisitRegistrationCalendarSlotDto
     */
    examTypeId?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof GetVisitRegistrationCalendarSlotDto
     */
    visitDateTime?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof GetVisitRegistrationCalendarSlotDto
     */
    visitTime?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GetVisitRegistrationCalendarSlotDto
     */
    appointmentChannelId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVisitRegistrationCalendarSlotDto
     */
    examTypeName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVisitRegistrationCalendarSlotDto
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetVisitRegistrationCalendarSlotDto
     */
    active?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetVisitRegistrationCalendarSlotDto
     */
    mine?: boolean | null;
}

/**
 * Check if a given object implements the GetVisitRegistrationCalendarSlotDto interface.
 */
export function instanceOfGetVisitRegistrationCalendarSlotDto(value: object): value is GetVisitRegistrationCalendarSlotDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function GetVisitRegistrationCalendarSlotDtoFromJSON(json: any): GetVisitRegistrationCalendarSlotDto {
    return GetVisitRegistrationCalendarSlotDtoFromJSONTyped(json, false);
}

export function GetVisitRegistrationCalendarSlotDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetVisitRegistrationCalendarSlotDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'firstname': json['firstname'] == null ? undefined : json['firstname'],
        'surname': json['surname'] == null ? undefined : json['surname'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'mail': json['mail'] == null ? undefined : json['mail'],
        'examTypeId': json['examTypeId'] == null ? undefined : json['examTypeId'],
        'visitDateTime': json['visitDateTime'] == null ? undefined : (new Date(json['visitDateTime'])),
        'visitTime': json['visitTime'] == null ? undefined : json['visitTime'],
        'appointmentChannelId': json['appointmentChannelId'] == null ? undefined : json['appointmentChannelId'],
        'examTypeName': json['examTypeName'] == null ? undefined : json['examTypeName'],
        'description': json['description'] == null ? undefined : json['description'],
        'active': json['active'] == null ? undefined : json['active'],
        'mine': json['mine'] == null ? undefined : json['mine'],
    };
}

export function GetVisitRegistrationCalendarSlotDtoToJSON(value?: GetVisitRegistrationCalendarSlotDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'firstname': value['firstname'],
        'surname': value['surname'],
        'phone': value['phone'],
        'mail': value['mail'],
        'examTypeId': value['examTypeId'],
        'visitDateTime': value['visitDateTime'] == null ? undefined : ((value['visitDateTime'] as any).toISOString()),
        'visitTime': value['visitTime'],
        'appointmentChannelId': value['appointmentChannelId'],
        'examTypeName': value['examTypeName'],
        'description': value['description'],
        'active': value['active'],
        'mine': value['mine'],
    };
}

